



















































































































import {Vue, Component, Watch} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import getConnection from "@/utils/signalr_connection";
import {State} from "vuex-class";
import axios from "axios";

@Component({name: 'poseta'})
export default class Poseta extends mixins(ComponentBaseMixin) {
  id = undefined;
  merchandiserId = undefined;
  messages = [];
  messageText = '';
  notes = [];
  grade = 0;
  storeName = '';
  storeAddress = '';
  storePublicId = '';
  storeId = ''
  publicVisitID = '';
  @State user;

  createdHook = false;
  isBusy = false;
  isBusySaveRate = false;

  //TODO: charts when fixed (interval 500)

  activated() {
    const routeParamID = this.$route.params.publicVisitID;
    if (routeParamID && routeParamID !== this.publicVisitID && this.createdHook === false) {
      this.loadVisit(routeParamID);
    }
    if (this.createdHook) {
      this.createdHook = false;
    }
  }

  created() {
    this.createdHook = true;
    const routeParamID = this.$route.params.publicVisitID;
    if (routeParamID) {
      this.loadVisit(routeParamID);
    }
    getConnection().on('receivedMessageFromAgent', this.onMessageReceived);
  }

  @Watch('$route.params.publicVisitID')
  visitChanged(publicId) {
    this.loadVisit(publicId);
  }

  async loadVisit(id) {
    if (!id) return;

    this.isBusy = true;
    this.axios.get(`api/GetVisitByPublicId/${id}`).then((result) => {
      this.id = result.data.id;
      this.merchandiserId = result.data.merchandiserId;
      this.storeId = result.data.storeId;
      this.storePublicId = result.data.storePublicId;
      this.storeName = result.data.storeName;
      this.storeAddress = `${result.data.storeAddress}, ${result.data.storeCity}`;
      this.messages = result.data.messages;
      this.publicVisitID = result.data.publicVisitId;
    }).catch(err => {
      this.showError('greskaPrilikomUcitavanja');
      this.isBusy = false;
    }).finally(() => this.isBusy = false);
    /*await this.axios.get(`api/mobile/stores/${this.storeId}/notes`).then((result) => {
      this.notes = result.data;
      this.isBusy = false;
    }).catch((err) => {
      this.isBusy = false;
      this.showError('greskaPrilikomUcitavanja');
    })*/
    let fancybox = $(".fancybox");
    fancybox.fancybox({
      animationEffect: 'zoom',
      transitionEffect: 'slide',
      thumbs: {
        autoStart: true,
      },
    });

    await axios.put(`/api/ReadMessagesFromVisit/${id}`);
  }

  async sendMessage() {
    if (this.messageText) {
      let message = {
        visitId: this.id,
        date: new Date(),
        from: {id: this.user.id, name: `${this.user.firstName} ${this.user.lastName}`, avatar: this.user.photo},
        to: {id: this.merchandiserId},
        message: this.messageText,
        read: false
      };
      try {
        await this.axios.post('api/SendMessageToMerchandiser', message);
        this.messages.push(message);
        this.messageText = '';
      } catch (e) {
        this.showError('porukaNijePoslata');
      }
    }
  }

  async saveRate() {
    if (this.isBusySaveRate) return;
    try {
      this.isBusySaveRate = true;
      await this.axios.put('api/visit/rateIt', {id: this.id, grade: this.grade});
    } catch (err) {
      this.showError('neuspesnoCuvanjePodataka');
      this.isBusySaveRate = false;
    } finally {
      this.showInfo('podaciUspesnoSacuvani');
      this.isBusySaveRate = false;
    }
  }

  onMessageReceived(msg) {
    if (msg.visitId == this.id) {
      this.messages.push(msg);
    }
  }

  destroyed() {
    getConnection().off('receivedMessageFromAgent', this.onMessageReceived);
  }
}
